import { AsyncType } from './state/async/constants';
import { asyncError, asyncInitial, asyncStart, asyncSuccess } from './state/async/reducers';
import { routeItem } from './state/draft/paths';
import { setArrayValueReducer, setTouchedReducer, setValueReducer, submitAttemptReducer, } from './state/draft/reducers';
import { DraftType } from './state/draft/types';
import { findNextGeoObject, setSuggestReducer, updateSuggestReducer } from './state/suggest/reducer';
import { isAddressValid } from './state/suggest/selectors';
import { SuggestType } from './state/suggest/types';
import { setZoneNameReducer, setZonePointReducer, updateZonePointBySuggest } from './state/zone/reducers';
import { ZoneType } from './state/zone/types';
export var reducer = function (state, action) {
    var _a;
    switch (action.type) {
        case ZoneType.SET_NAME:
            return setZoneNameReducer(state, action.payload);
        case ZoneType.SET_POINT:
            return setZonePointReducer(state, action.payload);
        case SuggestType.SET: {
            var nextState_1 = setSuggestReducer(state, action.payload);
            var nextGeoObject = findNextGeoObject(action.payload);
            if (nextGeoObject) {
                nextState_1 = setValueReducer(nextState_1, {
                    path: routeItem(action.payload.idx, 'address'),
                    value: {
                        geoObject: nextGeoObject,
                        isValid: isAddressValid(action.payload.request),
                    },
                });
            }
            return updateZonePointBySuggest(nextState_1, action.payload);
        }
        case DraftType.SET_VALUE:
            var nextState = setValueReducer(state, action.payload);
            // сброс юзер саджеста если ввели путой адрес, чтобы показать зеро
            if (((_a = action.payload.value) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('part')) && !action.payload.value.part) {
                var _b = action.payload.path, idx = _b[1];
                nextState = updateSuggestReducer(nextState, {
                    idx: idx,
                    suggest: {
                        userSuggest: undefined,
                    },
                });
            }
            return nextState;
        case DraftType.SET_ARRAY_VALUE:
            return setArrayValueReducer(state, action.payload);
        case DraftType.SET_TOUCHED:
            return setTouchedReducer(state, action.payload);
        case DraftType.SUBMIT_ATTEMPT:
            return submitAttemptReducer(state, action.payload);
        case AsyncType.INITIAL:
            return asyncInitial(state, action.payload);
        case AsyncType.START:
            return asyncStart(state, action.payload);
        case AsyncType.SUCCESS:
            return asyncSuccess(state, action.payload);
        case AsyncType.ERROR:
            return asyncError(state, action.payload);
    }
    return state;
};
// let reducer = baseReducer
//
// if (process.env.NODE_ENV === 'development') {
//   const { createLogger } = require('redux-logger')
//   const logger = createLogger({
//     diff: true,
//     collapsed: true,
//   })
//   const withLog = (r: typeof reducer) => (state: any, action: any) => {
//     const nextState = r(state, action)
//     let loggerState = state
//
//     const next: any = () => {
//       loggerState = nextState
//
//       return loggerState
//     }
//     const store: any = {
//       getState: () => loggerState,
//       dispatch: () => undefined,
//     }
//
//     logger(store)(next)(action)
//
//     return nextState
//   }
//
//   reducer = withLog(baseReducer)
// }
//
// export {
//   reducer,
// }
